import React from "react";
import "./underDevelopment.scss";
import { useLocation } from "react-router-dom";
import { capitalize } from "lodash";

const UnderConstruction = () => {
  const location = useLocation();
  console.log(
    "Check the location",
    location,
    location?.pathname.split("/").splice(-1)[0]
  );
  const pageName = location?.pathname.split("/").splice(-1)[0];
  return (
    <div className="under-construction">
      <div className="content">
        <h1>🚧 {capitalize(pageName)} page is Under Construction 🚧</h1>
        <p>We're working hard to bring you something amazing!</p>
        <div className="progress-bar-ud">
          <div className="progress-ud"></div>
        </div>
        <p className="launch-message">Launching soon...</p>
      </div>
    </div>
  );
};

export default UnderConstruction;
